import React, { useEffect, useState } from "react";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import {
  useCreateGroupStudioMutation,
  useEditGroupStudioMutation,
} from "../../../api/admin/gestisciStudioApi";
import { toast } from "react-toastify";
import { t } from "i18next";
import { useSelector } from "react-redux";

const CreateGruop = ({ group = null, onClose }) => {
  const adminId = useSelector((state) => state.app.adminId);
  const [formData, setFormData] = useState({});

  const [createGroup, { isLoading: loadingCreate }] =
    useCreateGroupStudioMutation();

  const [editGroup, { isLoading: loadingEdit }] = useEditGroupStudioMutation();

  useEffect(() => {
    if (group) {
      setFormData({
        name: group.name,
      });
    }
  }, [group]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSave = () => {
    if (group) {
      editGroup({
        id: group.id,
        groupName: formData.name,
        adminId: adminId,
      }).then((res) => {
        if (res?.data?.Result !== 1) {
          toast.error(t("NotEditedGroup"));
          return;
        }
        toast.success(t("EditedGroup"));
      });
    } else {
      createGroup({
        groupName: formData.name,
        adminId: adminId,
      }).then((res) => {
        if (res?.data?.Result !== 1) {
          toast.error(t("NotCreatedGroup"));
          return;
        }
        toast.success(t("CreatedGroup"));
      });
    }

    onClose();
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h3>{t("CreateGroup")}</h3>
      <div className=" w-2/3 space-y-5">
        <CoreInputField
          className="w-full"
          label={t("Name")}
          name="name"
          onChange={handleChange}
          value={formData?.name}
        />
      </div>

      <div className="flex justify-around mt-4 py-8">
        <CoreButton
          testo={loadingCreate || loadingEdit ? t("Wait") : t("Save")}
          className="bg-primary btn-round border-primary"
          onClick={handleSave}
          disabled={loadingCreate || loadingEdit}
        />
      </div>
    </div>
  );
};

export default CreateGruop;
